import { render, staticRenderFns } from "./CustomerDetailUsages.vue?vue&type=template&id=6cdb886c"
import script from "./CustomerDetailUsages.vue?vue&type=script&lang=js"
export * from "./CustomerDetailUsages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports